import { useEffect } from "react";
import { FeaturesHero } from "../components/features/FeaturesHero";
import { FeatureSelector } from "../components/features/FeatureSelector";
import { CoreFeatureSections } from "../components/features/CoreFeatureSections";
import { ActionFeatureSections } from "../components/features/ActionFeatureSections";
import { CreatorFeatureSections } from "../components/features/CreatorFeatureSections";
import { NetworkFeatureSections } from "../components/features/NetworkFeatureSections";
import { usePageMeta } from "../lib/usePageMeta";
import "../components/features/features.css";

export default function FeaturesPage() {
  usePageMeta("Features — Everything You Can Make Happen with HUMN", "Explore HUMN Ai, discovery, Happenings, human learning, communities, bookings, creator tools, Credits, chat and global discovery.");

  useEffect(() => {
    document.documentElement.classList.add("features-snap");
    return () => document.documentElement.classList.remove("features-snap");
  }, []);

  return (
    <main className="features-page" data-testid="features-page">
      <FeaturesHero />
      <div className="features-content-layout">
        <FeatureSelector />
        <div className="features-content-main">
          <section className="features-storyline" data-testid="features-storyline">
            <div className="features-shell">
              {["I have an intention", "HUMN understands", "The right people appear", "We take action", "Something happens"].map((step, index) => <div key={step}><small>0{index + 1}</small><strong>{step}</strong>{index < 4 && <span aria-hidden="true">→</span>}</div>)}
            </div>
          </section>
          <CoreFeatureSections />
          <ActionFeatureSections />
          <CreatorFeatureSections />
          <NetworkFeatureSections />
        </div>
      </div>
    </main>
  );
}